import { render } from "./SupplierInfo.vue?vue&type=template&id=4ed3e46a&scoped=true"
import script from "./SupplierInfo.vue?vue&type=script&lang=js"
export * from "./SupplierInfo.vue?vue&type=script&lang=js"

import "./SupplierInfo.vue?vue&type=style&index=0&id=4ed3e46a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed3e46a"]])

export default __exports__